module.exports = __webpack_public_path__ + "img/scuritycard.55f9a420.png";